import { render, staticRenderFns } from "./AvailableOpgs.vue?vue&type=template&id=284a0155&scoped=true"
import script from "./AvailableOpgs.vue?vue&type=script&lang=js"
export * from "./AvailableOpgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a0155",
  null
  
)

export default component.exports